import React from 'react';
import { useFeatureConfig } from '../../context/FeatureConfigContext';

const FeatureGuard = ({ feature, children, fallback = null }) => {
  const { isFeatureEnabled } = useFeatureConfig();

  if (!isFeatureEnabled(feature)) {
    return fallback || (
      <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-lg">
        <div className="text-6xl mb-4">🚧</div>
        <h3 className="text-xl font-semibold text-gray-800 mb-2">
          Feature นี้ยังไม่เปิดใช้งาน
        </h3>
        <p className="text-gray-600 text-center mb-4">
          Feature นี้จะเปิดใช้งานใน Phase 2
        </p>
        <p className="text-sm text-gray-500 text-center">
          กรุณาเรียนรู้ระบบพื้นฐานก่อน
        </p>
      </div>
    );
  }

  return children;
};

export default FeatureGuard;


